import React from 'react'
import { OptionTypeBase } from 'react-select'
import * as Form from '../../../Form'
import { Spinner } from '../../../Spinner'
import { Field, FormFacade, FieldInterceptChange, InterceptChangeEvent } from '../../types'
import { ReactComponent as ArrowSvg } from './arrow.svg'
import { StyledSelect, Container } from './styled'

interface Props {
  id?: string
  field?: Field<HTMLSelectElement, string>
  form?: FormFacade
  interceptChange?: FieldInterceptChange<string>
  label?: string
  options?: OptionTypeBase[]
  isDisabled?: boolean
  isLoading?: boolean
  isRequired?: boolean
  isReadOnly?: boolean
}

export type SelectFC = React.FC<Props>

export const Select: SelectFC = ({
  id,
  field,
  form,
  interceptChange,
  label,
  options,
  isRequired,
  isLoading,
  isDisabled,
  isReadOnly = false
}) => {
  const { name, value, onChange, onBlur } = field ?? {}
  const { errors, touched } = form ?? {}
  const hasError = name && errors?.[name] && touched?.[name]
  const _id = id ?? name

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    if (!name || !form) {
      return
    }

    const changeEvent: InterceptChangeEvent<string> = {
      value: event.target.value,
      name,
      form
    }

    const shouldIntercept = interceptChange?.(changeEvent)

    if (!shouldIntercept) {
      onChange?.(event)
    }
  }

  return (
    <Form.Field
      hasError={hasError}
      className={`form-field form-field--select ${hasError ? 'form-has-error' : ''}`}
    >
      <Container
        isLoading={isLoading}
        isDisabled={isDisabled}
      >
        {label && (
          <Form.Label htmlFor={_id}>
            <span>{label}</span>
            {isRequired && <em>*</em>}
          </Form.Label>
        )}

        <StyledSelect
          id={_id}
          name={name}
          value={value ?? ''}
          onChange={handleChange}
          onBlur={onBlur}
          disabled={isReadOnly || (isDisabled ?? isLoading)}
        >
          {options?.map((option, i) => (
            <option key={`${option.value}-${i}`} value={option.value}>{option.label}</option>
          ))}
        </StyledSelect>

        {isLoading && (
          <Spinner size={20} />
        )}

        <ArrowSvg
          className='select-arrow-expand'
        />
      </Container>

      {hasError && name && (
        <Form.Error>
          {errors?.[name]}
        </Form.Error>
      )}
    </Form.Field>
  )
}
